/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  ISettingsTable,
  ISettingsTableForExpansion
} from 'src/app/@amiga-pyme/interfaces/table.interface';
import {
  IAction,
  IEventAction
} from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { AmiTableTemplate } from 'src/app/@amiga-pyme/templates/ami-table.template';

@Component({
  selector: 'ami-table-expansion',
  templateUrl: './ami-table-expansion.component.html',
  styleUrls: ['./ami-table-expansion.component.scss']
})
export class AmiTableExpansionComponent extends AmiTableTemplate {
  mathMax = Math.max;
  @Input() actions: IAction[];
  @Output() action = new EventEmitter<IEventAction>();
  @Input() childSettings: ISettingsTable;
  @Input() childActions: IAction[];
  @Output() childAction = new EventEmitter<IEventAction>();
  @Input() showSearchHelpersOfChild = true;
  childData = null;

  settingsByChild: ISettingsTableForExpansion = {};
  childProductsByParent: any = {};

  selectedParent = null;

  ngOnChanges(changes: SimpleChanges) {
    const settings = this.settings;
    this._selectedColumns = settings.columns;
    const changesData = changes?.data.currentValue;
    if (changesData) {
      this.listingData = false;
      this.data = changesData;

      changesData.map((productParent) => {
        this.childProductsByParent[productParent['id']] = Object.values(
          productParent[settings.child.columnPatent.data]
        );

        this.settingsByChild[productParent['id']] = {
          ...this.childSettings
        };
        this.settingsByChild[productParent['id']].title =
          productParent[settings.child.columnPatent.title];
      });
    }
  }

  actionRow(action: any, rowData: unknown) {
    this.action.emit({ action: action?.name, data: rowData });
  }

  actionChildRow(event: any) {
    const { action, data } = event;
    const dataChildToEmit = {
      action,
      data: { selectedChild: data, selectedParent: this.selectedParent }
    };
    this.childAction.emit(dataChildToEmit);
  }

  onSelectParent(parent) {
    this.selectedParent = parent;
    this.setDataChild();
  }

  setDataChild() {
    if (!this.selectedParent) return null;
    const dataChild = this.parseDataChild(
      this.selectedParent[this.settings.child.columnPatent.data]
    );
    this.childData = dataChild;
    this.childSettings.title =
      this.selectedParent[this.settings.child.columnPatent.title];
  }

  parseDataChild(data: any) {
    const newData = [];
    Object.keys(data).map((key) => {
      data[key].format = key;
      newData.push(data[key]);
    });
    return newData;
  }

  objectToArray(obj: any): any[] {
    const obtArrayValues = Object.values(obj);
    return obtArrayValues;
  }
}
